import { useMutation } from "@tanstack/react-query";
import { api } from "../client";
import type {
  UserSuccessOutput,
  UserUserResetPasswordInput,
} from "../../generated/fresh-guard-api";

export function useUserResetPassword() {
  return useMutation({
    mutationFn: async (input: {
      userUserResetPasswordInput: UserUserResetPasswordInput;
    }) => {
      const res = await api.userApi.apiUserResetPasswordPut(
        input.userUserResetPasswordInput,
      );
      return res.data as UserSuccessOutput;
    },
    meta: {
      skipGlobalError: false,
    },
  });
}
